// src/images/RelicVault/index.js
//
// Static asset map for the Relic Vault Store and Vault browser, ported from the
// designer's handoff (public/assets in relic-vault-react).
//
// - RELIC_SHEETS: 135 sprite sheets, each a 3x2 grid of 160x160 relic icons
//   (480x320 total). A relic points at one sheet + an offset; see RelicSprite.
//   Keep these as sheets - do not split them into 675 separate files.
// - COMPANION_ART: cropped transparent character art (store cards, vault header).
// - COMPANION_INTRO: the full "Meet <name>" reveal graphic with copy baked in,
//   used only by the purchase modal.
// - GUILD_HEADSHOTS: small circular avatars for the vault sidebar.

/* eslint-disable global-require */

export const RELIC_SHEETS = [
  require('./relic-sheets/vault-sheet-0.webp'),
  require('./relic-sheets/vault-sheet-1.webp'),
  require('./relic-sheets/vault-sheet-2.webp'),
  require('./relic-sheets/vault-sheet-3.webp'),
  require('./relic-sheets/vault-sheet-4.webp'),
  require('./relic-sheets/vault-sheet-5.webp'),
  require('./relic-sheets/vault-sheet-6.webp'),
  require('./relic-sheets/vault-sheet-7.webp'),
  require('./relic-sheets/vault-sheet-8.webp'),
  require('./relic-sheets/vault-sheet-9.webp'),
  require('./relic-sheets/vault-sheet-10.webp'),
  require('./relic-sheets/vault-sheet-11.webp'),
  require('./relic-sheets/vault-sheet-12.webp'),
  require('./relic-sheets/vault-sheet-13.webp'),
  require('./relic-sheets/vault-sheet-14.webp'),
  require('./relic-sheets/vault-sheet-15.webp'),
  require('./relic-sheets/vault-sheet-16.webp'),
  require('./relic-sheets/vault-sheet-17.webp'),
  require('./relic-sheets/vault-sheet-18.webp'),
  require('./relic-sheets/vault-sheet-19.webp'),
  require('./relic-sheets/vault-sheet-20.webp'),
  require('./relic-sheets/vault-sheet-21.webp'),
  require('./relic-sheets/vault-sheet-22.webp'),
  require('./relic-sheets/vault-sheet-23.webp'),
  require('./relic-sheets/vault-sheet-24.webp'),
  require('./relic-sheets/vault-sheet-25.webp'),
  require('./relic-sheets/vault-sheet-26.webp'),
  require('./relic-sheets/vault-sheet-27.webp'),
  require('./relic-sheets/vault-sheet-28.webp'),
  require('./relic-sheets/vault-sheet-29.webp'),
  require('./relic-sheets/vault-sheet-30.webp'),
  require('./relic-sheets/vault-sheet-31.webp'),
  require('./relic-sheets/vault-sheet-32.webp'),
  require('./relic-sheets/vault-sheet-33.webp'),
  require('./relic-sheets/vault-sheet-34.webp'),
  require('./relic-sheets/vault-sheet-35.webp'),
  require('./relic-sheets/vault-sheet-36.webp'),
  require('./relic-sheets/vault-sheet-37.webp'),
  require('./relic-sheets/vault-sheet-38.webp'),
  require('./relic-sheets/vault-sheet-39.webp'),
  require('./relic-sheets/vault-sheet-40.webp'),
  require('./relic-sheets/vault-sheet-41.webp'),
  require('./relic-sheets/vault-sheet-42.webp'),
  require('./relic-sheets/vault-sheet-43.webp'),
  require('./relic-sheets/vault-sheet-44.webp'),
  require('./relic-sheets/vault-sheet-45.webp'),
  require('./relic-sheets/vault-sheet-46.webp'),
  require('./relic-sheets/vault-sheet-47.webp'),
  require('./relic-sheets/vault-sheet-48.webp'),
  require('./relic-sheets/vault-sheet-49.webp'),
  require('./relic-sheets/vault-sheet-50.webp'),
  require('./relic-sheets/vault-sheet-51.webp'),
  require('./relic-sheets/vault-sheet-52.webp'),
  require('./relic-sheets/vault-sheet-53.webp'),
  require('./relic-sheets/vault-sheet-54.webp'),
  require('./relic-sheets/vault-sheet-55.webp'),
  require('./relic-sheets/vault-sheet-56.webp'),
  require('./relic-sheets/vault-sheet-57.webp'),
  require('./relic-sheets/vault-sheet-58.webp'),
  require('./relic-sheets/vault-sheet-59.webp'),
  require('./relic-sheets/vault-sheet-60.webp'),
  require('./relic-sheets/vault-sheet-61.webp'),
  require('./relic-sheets/vault-sheet-62.webp'),
  require('./relic-sheets/vault-sheet-63.webp'),
  require('./relic-sheets/vault-sheet-64.webp'),
  require('./relic-sheets/vault-sheet-65.webp'),
  require('./relic-sheets/vault-sheet-66.webp'),
  require('./relic-sheets/vault-sheet-67.webp'),
  require('./relic-sheets/vault-sheet-68.webp'),
  require('./relic-sheets/vault-sheet-69.webp'),
  require('./relic-sheets/vault-sheet-70.webp'),
  require('./relic-sheets/vault-sheet-71.webp'),
  require('./relic-sheets/vault-sheet-72.webp'),
  require('./relic-sheets/vault-sheet-73.webp'),
  require('./relic-sheets/vault-sheet-74.webp'),
  require('./relic-sheets/vault-sheet-75.webp'),
  require('./relic-sheets/vault-sheet-76.webp'),
  require('./relic-sheets/vault-sheet-77.webp'),
  require('./relic-sheets/vault-sheet-78.webp'),
  require('./relic-sheets/vault-sheet-79.webp'),
  require('./relic-sheets/vault-sheet-80.webp'),
  require('./relic-sheets/vault-sheet-81.webp'),
  require('./relic-sheets/vault-sheet-82.webp'),
  require('./relic-sheets/vault-sheet-83.webp'),
  require('./relic-sheets/vault-sheet-84.webp'),
  require('./relic-sheets/vault-sheet-85.webp'),
  require('./relic-sheets/vault-sheet-86.webp'),
  require('./relic-sheets/vault-sheet-87.webp'),
  require('./relic-sheets/vault-sheet-88.webp'),
  require('./relic-sheets/vault-sheet-89.webp'),
  require('./relic-sheets/vault-sheet-90.webp'),
  require('./relic-sheets/vault-sheet-91.webp'),
  require('./relic-sheets/vault-sheet-92.webp'),
  require('./relic-sheets/vault-sheet-93.webp'),
  require('./relic-sheets/vault-sheet-94.webp'),
  require('./relic-sheets/vault-sheet-95.webp'),
  require('./relic-sheets/vault-sheet-96.webp'),
  require('./relic-sheets/vault-sheet-97.webp'),
  require('./relic-sheets/vault-sheet-98.webp'),
  require('./relic-sheets/vault-sheet-99.webp'),
  require('./relic-sheets/vault-sheet-100.webp'),
  require('./relic-sheets/vault-sheet-101.webp'),
  require('./relic-sheets/vault-sheet-102.webp'),
  require('./relic-sheets/vault-sheet-103.webp'),
  require('./relic-sheets/vault-sheet-104.webp'),
  require('./relic-sheets/vault-sheet-105.webp'),
  require('./relic-sheets/vault-sheet-106.webp'),
  require('./relic-sheets/vault-sheet-107.webp'),
  require('./relic-sheets/vault-sheet-108.webp'),
  require('./relic-sheets/vault-sheet-109.webp'),
  require('./relic-sheets/vault-sheet-110.webp'),
  require('./relic-sheets/vault-sheet-111.webp'),
  require('./relic-sheets/vault-sheet-112.webp'),
  require('./relic-sheets/vault-sheet-113.webp'),
  require('./relic-sheets/vault-sheet-114.webp'),
  require('./relic-sheets/vault-sheet-115.webp'),
  require('./relic-sheets/vault-sheet-116.webp'),
  require('./relic-sheets/vault-sheet-117.webp'),
  require('./relic-sheets/vault-sheet-118.webp'),
  require('./relic-sheets/vault-sheet-119.webp'),
  require('./relic-sheets/vault-sheet-120.webp'),
  require('./relic-sheets/vault-sheet-121.webp'),
  require('./relic-sheets/vault-sheet-122.webp'),
  require('./relic-sheets/vault-sheet-123.webp'),
  require('./relic-sheets/vault-sheet-124.webp'),
  require('./relic-sheets/vault-sheet-125.webp'),
  require('./relic-sheets/vault-sheet-126.webp'),
  require('./relic-sheets/vault-sheet-127.webp'),
  require('./relic-sheets/vault-sheet-128.webp'),
  require('./relic-sheets/vault-sheet-129.webp'),
  require('./relic-sheets/vault-sheet-130.webp'),
  require('./relic-sheets/vault-sheet-131.webp'),
  require('./relic-sheets/vault-sheet-132.webp'),
  require('./relic-sheets/vault-sheet-133.webp'),
  require('./relic-sheets/vault-sheet-134.webp'),
];

export const COMPANION_ART = {
  quik: require('./companion-art/quik.webp'),
  ember: require('./companion-art/ember.webp'),
  echo: require('./companion-art/echo.webp'),
  holly: require('./companion-art/holly.webp'),
  atlas: require('./companion-art/atlas.webp'),
  astra: require('./companion-art/astra.webp'),
  newton: require('./companion-art/newton.webp'),
  nova: require('./companion-art/nova.webp'),
  ace: require('./companion-art/ace.webp'),
};

/**
 * Width / height of each COMPANION_ART image. The design sizes the art by height
 * with auto width, which React Native cannot infer from an asset.
 */
export const COMPANION_ART_ASPECT = {
  quik: 420 / 408,
  ember: 280 / 420,
  echo: 295 / 420,
  holly: 351 / 420,
  atlas: 280 / 420,
  astra: 350 / 420,
  newton: 351 / 420,
  nova: 280 / 420,
  ace: 301 / 420,
};

export const COMPANION_INTRO = {
  quik: require('./companion-intro/quik.webp'),
  ember: require('./companion-intro/ember.webp'),
  echo: require('./companion-intro/echo.webp'),
  holly: require('./companion-intro/holly.webp'),
  atlas: require('./companion-intro/atlas.webp'),
  astra: require('./companion-intro/astra.webp'),
  newton: require('./companion-intro/newton.webp'),
  nova: require('./companion-intro/nova.webp'),
  ace: require('./companion-intro/ace.webp'),
};

export const GUILD_HEADSHOTS = {
  quik: require('./guild-headshots/quik.png'),
  ember: require('./guild-headshots/ember.png'),
  echo: require('./guild-headshots/echo.png'),
  holly: require('./guild-headshots/holly.png'),
  atlas: require('./guild-headshots/atlas.png'),
  astra: require('./guild-headshots/astra.png'),
  newton: require('./guild-headshots/newton.png'),
  nova: require('./guild-headshots/nova.png'),
  ace: require('./guild-headshots/ace.png'),
};

export const BRAND = {
  badge: require('./brand/quiklearn-badge.png'),
  vaultPanelTexture: require('./brand/vault-panel-texture.jpg'),
};

/** Sprite sheet for a relic's sheetClass, e.g. "vsheet-42". */
export function relicSheetFor(sheetClass) {
  const index = Number(String(sheetClass || '').replace('vsheet-', ''));
  return Number.isInteger(index) ? RELIC_SHEETS[index] || null : null;
}
